import { lazy } from "react";

export const routes = {
  alertChimeScreen: {
    path: "/bed-exit/chime/:residentId/:roomName/:clinicId/:sound",
    element: lazy(() => import("../../pages/AlertChime")),
  },
  escalationChimeScreen: {
    path: "/escalation/chime/:residentId/:roomName/:clinicId/:sound/:escalationId",
    element: lazy(() => import("../../pages/EscalationChime")),
  },
  flagChimeScreen: {
    path: "/flag/chime/:residentId/:roomName/:clinicId/:sound/:psnFlagId",
    element: lazy(() => import("../../pages/FlagChime")),
  },
  riskReport: {
    path: "/public/risk-report",
    element: lazy(() => import("../../pages/Reports/AIRiskReportPage")),
  },
  telehealthJoin: {
    path: "/public/telehealth/join/:token",
    element: lazy(() => import("../../pages/TelehealthJoin")),
  },
  getStarted: {
    path: "/get-started",
    element: lazy(() => import("../../pages/GetStarted")),
  },
  login: {
    path: "/login",
    element: lazy(() => import("../../pages/Login")),
  },
  signup: {
    path: "/signup",
    element: lazy(() => import("../../pages/SignUp")),
  },
  ssoLogin: {
    path: "/sso/login",
    element: lazy(() => import("../../pages/Sso/Login")),
  },
  zpaxSsoLogin: {
    path: "/zpax-sso/login",
    element: lazy(() => import("../../pages/ZpaxSso/Login")),
  },
  microsoftSsoLogin: {
    path: "/microsoft-sso/login",
    element: lazy(() => import("../../pages/MicrosoftSso/Login")),
  },
  pinForm: {
    path: "/pin-form",
    element: lazy(() => import("../../pages/PinScreen")),
  },
  SummaryScreen: {
    path: "/summary",
    element: lazy(() => import("../../pages/SummaryScreen")),
  },
  // ⛔️ADD MORE ROUTE ABOVE THIS LINE⛔️
  residentElementStar: {
    path: "*",
    element: lazy(() => import("./redirectElement")),
  },
  termsOfUse: {
    path: "/terms-of-use",
    element: lazy(() => import("../../pages/TermsOfUse")),
  },
  privacyPolicy: {
    path: "/privacy-policy",
    element: lazy(() => import("../../pages/PrivacyPolicy")),
  },
} as const;
